import actions from './constants';

export const fetchDatasetMarkdownSuccess = (category, code, result) => ({
  category,
  code,
  result,
  type: actions.FETCH_DATASET_MARKDOWN_SUCCESS,
});

export const fetchDatasetMarkdownError = (category, code, error) => ({
  category,
  code,
  error,
  type: actions.FETCH_DATASET_MARKDOWN_ERROR,
});

export const closeDatasetMarkdown = ({ category, code }) => ({
  category,
  code,
  type: actions.CLOSE_DATASET_MARKDOWN,
});
